import { useState, useEffect } from "react";

import Config from "../../Config";

import empty_user from "../../empty_user.png";
import send_comment from "../../send_comment.png";

import InputText from "../../helpers/InputText";
import InputTextArea from "../../helpers/InputTextArea";


function WallComment(props)
{

    const[tab,setTab] = useState(props.tab);
    const[view,setView] = useState("line");


    const [row, setRow] = useState({
        komentarz: ''
    });


    const valChange = (filedName, val, correct, msg) => {

        //console.log(filedName + " " + val);
      
        setRow( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );         
    }

    const goNext = () => {
        console.log("goNext");
    }


    const addComment = (e) => {

       
        if(row.komentarz.length < 1)
        {
            return;
        }


        var operacja = e.target.getAttribute("t");
 
            props.mainView.setProgress(-2);
    
            var req = {
                id: props.typId,
                komentarz: row.komentarz,        
            };
    
            fetch( Config.url + '/rest_v1_news,add_comment', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => { 
    
                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            setTab(res.result);      
                            setRow({ ...row, ["komentarz"]:'' });        
                        }
             } )
             .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
             });
                       
    
             return false;
      
    
    }


    const delComment = (e) => {


        var idx = e.target.getAttribute("id");

        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć komentarz?", "yesno", (option)=>{
          
            ///--------
            if(option == "yes") sendDel(idx);
            //--------
} );

    }
    
    const sendDel = (idx) => {
 
 
            props.mainView.setProgress(-2);
    
            var req = {
                id: idx             
            };
    
            fetch( Config.url + '/rest_v1_news,del_comment', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => { 
    
                        props.mainView.setProgress(-1);        
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                            props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        }else    
                        {
                            setTab(res.result);                                  
                        }
             } )
             .catch(err => {          
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                        props.mainView.setProgress(-1);
             });
                       
    
             return false;
      
    
    }

     

 

    return (
        <div className="item_comment">

                <div>
                    {
                        tab.map( (item, ix) => {


                            
                         var defAwatar =           <img  src={empty_user} />
                        if(item.awatar.length> 10) defAwatar = <img  src={ "data:image/jpeg;base64, " + item.awatar} />

                        var del = <sup className="link_color" id={item.id} onClick={delComment} >usuń</sup>;
                        if(item.wlasciciel != '1') del = null;

                            return (
                                <div className="one_comment" key={ix}>
                                        <div className="comment_title">{defAwatar}  {item.tytul + ": "} {del} </div>
                                        <div className="comment_txt">{item.opis}</div>
                                </div>
                            )
                        } )
                    }
                </div>
 

                <br/>
                <div>
                   <InputTextArea    value={row.komentarz} valChange={valChange} goNext={goNext} name="komentarz" placeholder={  "Komentarz: "} className=' p95 ' req='0' />                                                             
                   <span className="btn"  onClick={addComment}>publikuj komentarz</span>
                </div>
                
                
        </div>
    )
}

export default WallComment;